module.exports = __webpack_public_path__ + "static/media/img-heritage-map--sp.b755633e.svg";